module.exports = __webpack_public_path__ + "static/practice-portuguese-e483c013a82786ab79b930feca5b5b2c.png";